import { SHOW_ALL, TAG_FAVORITE } from "@shared/constants/game";
import { TAG_RECOMMENDED } from "@shared/modules/recommended-games";
import { RunType } from "@shared/types";

export function getGameRunType(
  value: typeof TAG_FAVORITE | typeof TAG_RECOMMENDED | typeof SHOW_ALL | string
): RunType {
  if (value === TAG_FAVORITE) {
    return RunType.favourites;
  }

  if (value === TAG_RECOMMENDED) {
    return RunType.recommendation;
  }

  return RunType.game_list;
}
